export default __webpack_public_path__ + "assets/images/82a7f53f400f76d44befb00a2b060b0e.svg";